import React from 'react';
import { HeroVariant73 } from '../components/HeroVariant73';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage73() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1798">
      <Navigation data-id="element-1799" />
      <main data-id="element-1800">
        <HeroVariant73 data-id="element-1801" />
        <WhyUs data-id="element-1802" />
        <Services data-id="element-1803" />
        <FAQ data-id="element-1804" />
        <Testimonials data-id="element-1805" />
        <Consultation data-id="element-1806" />
      </main>
      <Footer data-id="element-1807" />
      <CookieBanner data-id="element-1808" />
      <FloatingContact data-id="element-1809" />
    </div>;
}